import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "userSheet",
  props: {
    sheetType: {
      type: String,
      default: ""
    },
    sheetList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var router = useRouter();

    var userSheetClick = function userSheetClick(id) {
      router.push("/main/playlistdetail/".concat(id));
    };

    var isList = ref(false);
    /* 显示和隐藏列表内容 */

    var titleClick = function titleClick() {
      isList.value = !isList.value;
    };

    return {
      isList: isList,
      userSheetClick: userSheetClick,
      titleClick: titleClick
    };
  },
  components: {}
});